import React, { useEffect, useState } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { TeamAvatar as TeamAvatarNext } from '@atlassian/people-teams-ui/team-avatar';

import { getColorFromString } from '../../utils/header-gradient';

import * as Styled from './TeamAvatar.styled';

interface Props {
	teamId: string;
	avatarUrl?: string;
}

const TeamAvatarLegacy = ({ avatarUrl, teamId }: Props) => {
	const [hasError, setError] = useState(false);

	useEffect(() => {
		setError(false);
	}, [avatarUrl, teamId]);

	if (hasError) {
		return <Styled.GradientImage gradientValues={getColorFromString(teamId)} />;
	}

	return <Styled.Image src={avatarUrl} onError={() => setError(true)} alt="" />;
};

export function TeamAvatar(props: Props) {
	if (fg('use_consistent_default_gradient_component')) {
		return <TeamAvatarNext {...props} />;
	}
	return <TeamAvatarLegacy {...props} />;
}

export default TeamAvatar;
